/* eslint-disable camelcase */
export class PaymentInfoTrackingModel {
  gt_ProductValue: number;

  gt_CouponCode: string;

  course: string;

  constructor(paymentValue: number, partnerCode: string, courseName: string) {
    this.gt_ProductValue = paymentValue;
    this.gt_CouponCode = partnerCode;
    this.course = courseName;
  }
}
